import getInitialReducerState from "../utils/getInitialReducerState"

import { DispatchLockingSystemReducer } from ".."
import { CountryCode } from "@secureo/common/typings/CountryCode"
import { LockingSystemCategory } from "@secureo/common/typings/Category"
import { SavedLockingSystem } from "@secureo/common/typings/LockingSystem"
import getInitialReducerStateFromSavedLockingSystem from "../utils/getInitialReducerStateFromSavedLockingSystem"

export const resetReducerState = async (
	accessToken: string,
	dispatch: DispatchLockingSystemReducer,
	lockingSystemCategory: LockingSystemCategory,
	locale: string,
	countryCode: CountryCode,
	isDebug: boolean,
	savedLockingSystem?: SavedLockingSystem,
	isOwner?: boolean,
) => {
	console.info("Resetting reducer state")

	if (savedLockingSystem) {
		dispatch({
			type: "SET_IS_LOADING",
			payload: true,
		})
		const payload = await getInitialReducerStateFromSavedLockingSystem(
			accessToken,
			lockingSystemCategory,
			locale,
			countryCode,
			isDebug,
			savedLockingSystem,
			isOwner,
		)

		dispatch({
			type: "LOAD_SAVED_LOCKING_SYSTEM",
			payload,
		})
	} else {
		dispatch({
			type: "RESET_STATE",
			payload: getInitialReducerState(
				lockingSystemCategory,
				locale,
				countryCode,
				isDebug,
				false,
			),
		})
	}
}
